import appconfig from '@/utils/appConfig';
import Image from 'next/image';

const TrustPilotReviews = () => {
    return (
        <a
            id="profileUrl"
            target="_blank"
            className="button flex items-center px-4"
            href="https://uk.trustpilot.com/review/pennycarhire.co.uk?utm_medium=trustbox&amp;utm_source=TrustBoxReviewCollector"
        >
            <div
                className={`${appconfig.colors.coloredSectionBorder} mx-auto border-2 flex w-full md:w-1/2 p-4 items-center justify-center mb-4 rounded-md`}
            >
                <span
                    id="translations-reviewuson"
                    className="text-xl md:text-3xl font-bold whitespace-nowrap"
                >
                    Review us on
                </span>
                <div id="tp-widget-logo">
                    <Image
                        unoptimized={true}
                        src="/images/trustpilot/Trustpilot_logo.png"
                        alt="Trustpilot"
                        width={200}
                        height={150}
                        className="w-24 md:w-48 ml-2"
                    />
                </div>
            </div>
        </a>
    );
};

export default TrustPilotReviews;
